<template>
  <div>
    <div
        v-click-outside="close"
        class="d-flex ai-center"
        selenium="header-username-link"
        tabindex="0"
        @keypress.enter.space="toggle"
        @click="toggle">
      <slot name="button"/>
    </div>
    <portal to="HEADER_MENU">
      <transition name="fade-up">
        <div
            v-if="isOpen"
            :aria-hidden="isOpen"
            class="HEADER-MENU"
            role="menu"
            selenium="header-menu">
          <slot name="drawer"/>
        </div>
      </transition>
    </portal>
  </div>
</template>

<script>
export default {
  name: 'header-menu',
  provide () {
    return {
      $menu: this.$data,
    };
  },
  data () {
    return {
      isOpen: false,
    };
  },
  methods: {
    close () {
      // We have to do this b/c on mobile
      // the drawer closes before link click is triggered
      setTimeout(() => {
        this.isOpen = false;
      }, 100);
    },
    toggle () {
      if (this.isOpen) {
        this.close();
      } else {
        this.isOpen = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.HEADER-MENU {
  position: absolute;
  top: 0;
  right: 0;
  box-shadow: 0px 2px 2px 0 rgba(0, 0, 0, 0.2);
  z-index: 3;
  border-top: 1px solid $color-gray70;

  @include mobile-only () {
    width: 100%;
  }

  @include tablet () {
    @include margin-top(-1);
  }
}
</style>
